/* Copyright (c) 2023-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

// TODO: AVENGERS-2507 - Find a way to share the single scale variable across scss & ts codes
export const TvFontSizeScale = 2; // scaling factor for tvMode
export const TvImageSizeScale = 1.5; // scaling factor for tvMode

// Custom breakpoint values taken from hig-rwd.scss
export const RwdS2S3MaxHeight = 480;

export const HigBreakpoints = {
    MaxS1Width: 479,
    MaxS2Width: 719,
    MinS3Width: 720,
    MaxS3Width: 959,
    MaxS4Width: 1439,
    MaxS5Width: 1919,
    MinS6Width: 1920
} as const;
